export default __webpack_public_path__ + "static/media/xacademy for LM.004175a3.svg";